import * as React from 'react';
import Navigation from './routes'
import { BrowserRouter as Router } from "react-router-dom";
import './App.css';


export default function App() {
  return (
      <Router>
        <Navigation />
      </Router>
  )
}
